import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-vorlagen-liste-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollVorlagenListeAdminEffects {

    FunkprotokollVorlagenListeAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN),
        mergeMap((x: ac.GetFunkprotokollVorlagenListeAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollVorlagenListeAdmin().pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollVorlagenListeAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollVorlagenListeAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollVorlageQueryService);
        }
        return this.service;
    }
}
